import React from 'react'
import { useAuth } from '../hooks/useAuth'
import Journal from '../components/Journal'

export default function JournalPage({ onNavigate }) {
  const { user, profile } = useAuth()

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.backBtn} onClick={() => onNavigate('dashboard')}>←</div>
        <div style={s.headerTitle}>Daily Journal</div>
        <div style={{ width: 36 }} />
      </div>
      <div style={s.main}>
        <Journal userId={user?.id} />
      </div>
    </div>
  )
}

const s = {
  page: { minHeight: '100vh', background: '#111118', color: '#e8e6df', fontFamily: "'DM Sans', sans-serif", position: 'relative' },
  header: { position: 'sticky', top: 0, zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: 'max(18px, env(safe-area-inset-top))', paddingBottom: '18px', paddingLeft: '24px', paddingRight: '24px', background: 'rgba(10,10,18,0.85)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(255,255,255,0.12)' },
  backBtn: { width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.07)', borderRadius: '10px', cursor: 'pointer', fontSize: '18px', color: '#c9a84c' },
  headerTitle: { fontFamily: "'Bebas Neue', sans-serif", fontSize: '20px', letterSpacing: '3px', color: '#e8e6df' },
  main: { maxWidth: '420px', margin: '0 auto', padding: '24px 20px 100px' },
}
